<div class="container">
  <div class="language-toggle">
    <button (click)="setLanguage('is')" [class.active]="language === 'is'">Íslenska</button>
    <button (click)="setLanguage('en')" [class.active]="language === 'en'">English</button>
  </div>

  <div class="text-center" style="margin: 20px 0;">
    <img src="https://ello-bucket.s3.amazonaws.com/ello/6407d3b9a083250fe818445f43df85f2630f72db.svg" alt="">
  </div>

  <div *ngIf="language === 'is'">
    <h1>Persónuverndarstefna</h1>
    <p>Högnun slf. (Kt: 4410110910)</p>
    <p>Reykjavík, Ísland</p>
    <p>06. júlí 2024</p>
    <p>Við biðjum þig um að lesa þessa persónuverndarstefnu vefsíðu vandlega þar sem hún inniheldur mikilvægar
      upplýsingar um hver við erum, hvernig og hvers vegna við söfnum, geymum, notum og deilum persónulegum upplýsingum,
      réttindi þín í tengslum við persónuupplýsingar þínar og hvernig á að hafa samband okkur og eftirlitsyfirvöldum ef
      þú hefur kvörtun.</p>
    <p>Þessir notkunarskilmálar (skilmálar) útskýra hvernig þú getur notað þessa vefsíðu (ello.is) eða farsímaforritið
      okkar (App) og eitthvað af innihaldi þess. Þessir skilmálar eiga við á milli Ello (við, okkur eða okkar) og þín,
      einstaklingsins sem opnar eða notar síðuna eða appið okkar (þú eða þitt). Þú ættir að lesa þessa skilmála vandlega
      áður en þú notar síðuna eða forritið okkar. Með því að nota síðuna eða appið eða gefa á annan hátt til kynna
      samþykki þitt samþykkir þú að vera bundið af þessum skilmálum. Ef þú ert ekki sammála einhverjum þessara skilmála
      ættirðu að hætta nota síðuna eða appið strax.</p>
    <p>Þessi persónuverndarstefna uppfyllir kröfur laga um persónuvernd og vinnslu persónuupplýsinga nr 90/2018, sbr.
      Reglugerð Evrópuþingsins og ráðsins (ESB) 2016/679 og var unnin með hana til hliðsjónar.</p>
    <h2>Um okkur</h2>
    <p>Við erum Ello, lífsstílsforrit hannað fyrir heildræna nálgun á heilsu.</p>
    <h2>Vefsíða okkar og farsímaforrit</h2>
    <p>Þessi persónuverndarstefna tengist notkun þinni á vefsíðu okkar, ello.is og farsímaforritinu. Síðan okkar og app
      geta innihaldið tengla á vefsíður þriðja aðila, viðbætur og forrit. Með því að smella á þá tengla eða virkja
      þessar tengingar gæti þriðju aðilum gert að safna eða deila gögnum um þig. Við stjórnum ekki þessum vefsíðum
      þriðja aðila og berum við ekki ábyrgð á persónuverndaryfirlýsingum sínum. Þegar þú yfirgefur síðuna okkar eða app,
      munum við hvetja þig til að lesa persónuverndartilkynningu allra vefsvæða sem þú heimsækir.</p>
    <h2>Söfnun okkar og notkun á persónulegum upplýsingum þínum</h2>
    <p>Við söfnum persónuupplýsingum um þig þegar þú opnar síðuna okkar eða notar appið okkar. Við söfnum þessum
      persónuupplýsingum frá þér annað hvort beint, svo sem þegar þú hefur samband við okkur eða óbeint, svo sem
      vafravirkni þína á síðunni okkar eða appi (sjá „Kökur“ hér að neðan).</p>
    <p>Við notum Firebase þjónustur (þar á meðal Firebase Messaging, Realtime Database, Storage og Crashlytics) til að
      styðja við nauðsynlega virkni forrita. Firebase kann að safna auðkennum (eins og tækjaauðkennum,
      uppsetningarauðkennum eða hrunskrám) og notkunargögnum til að virkja eiginleika eins og spjallskilaboð,
      tilkynningar, samstillingu gagna í rauntíma, skýgeymslu og hrun-/villutilkynningar. Google vinnur úr þessum gögnum
      í samræmi við persónuverndar- og öryggisstefnu Firebase.
    </p>
    <p>Við notum Glide, myndasafn sem hleður og vistar myndir í skyndiminni, til að birta og geyma myndir í appinu.
      Glide kann að vista myndir tímabundið í skyndiminni (þar á meðal myndir frá utanaðkomandi vefslóðum) á tækinu þínu
      til að bæta afköst. Glide sjálft safnar ekki persónuupplýsingum.
    </p>
    <p>Persónuupplýsingarnar sem við söfnum um þig eru háðar tilteknum athöfnum framkvæmt í gegnum síðuna okkar eða app.
      Þessar upplýsingar innihalda:</p>
    <ul>
      <li><strong>Auðkennisgögn</strong><br>Inniheldur fornafn, millinafn, eftirnafn, notendanafn eða álíka auðkenni,
        fæðingardagur og upphafsdagsetning þín innan forritsins.</li>
      <li><strong>Tengiliðagögn</strong><br>Inniheldur heimilisfang innheimtu, netfang og símanúmer.</li>
      <li><strong>Fjárhagsgögn</strong><br>Inniheldur bankareikninga og greiðslukortaupplýsingar eða annars konar
        rafræna greiðslu og greiðslum sem þú greiðir til okkar.</li>
      <li><strong>Færslugögn</strong><br>Inniheldur upplýsingar um greiðslur til og frá þér og aðrar upplýsingar af
        vörum og þjónustu sem þú hefur keypt af okkur.</li>
      <li><strong>Tæknigögn</strong><br>Inniheldur netsamskiptareglur (IP) vistfang, innskráningargögn þín, gerð vafra
        og útgáfa, tímabeltisstilling og staðsetning, gerðir og útgáfur vafraviðbóta, umferð, gögn, staðsetningargögn
        stýrikerfi og vettvang og önnur tækni á tæki sem þú notar til að fá aðgang að síðunni okkar eða appi.</li>
      <li><strong>Prófílgögn</strong><br>Inniheldur notendanafn þitt, kaup eða pantanir sem þú hefur gert, endurgjöf og
        könnunarsvör.</li>
      <li><strong>Notkunargögn</strong><br>Inniheldur upplýsingar um hvernig þú notar síðuna okkar eller app, forrit,
        vörur og þjónustu.</li>
      <li><strong>Markaðs- og samskiptagögn</strong><br>Inniheldur óskir þínar við móttöku markaðssetningu frá okkur og
        þriðja aðila okkar og samskipta valkostum þínum.</li>
    </ul>
    <p>Við gætum einnig safnað, notað og deilt samansöfnuðum gögnum eins og tölfræði eða lýðfræðileg gögn í hvaða
      tilgangi sem er. Uppsöfnuð gögn gætu verið fengin úr þínum persónuupplýsingar en teljast ekki persónuupplýsingar í
      lögum þar sem þessi gögn gera það ekki beint eða afhjúpa óbeint hver þú ert. Til dæmis gætum við safnað saman
      notkunargögnum þínum til reikna út hlutfall notenda sem fá aðgang að tilteknum vefsíðueiginleika. Hins vegar, ef
      við sameinum eða tengjum samansöfnuð gögn við persónuleg gögn þín svo að það sé hægt auðkennum þig beint eða
      óbeint, meðhöndlum við sameinuð gögn sem persónuupplýsingar sem verður notað í samræmi við þessa
      persónuverndartilkynningu.</p>
    <p>Þar sem við þurfum að safna persónuupplýsingum samkvæmt lögum eða samkvæmt samningsskilmálum og þú kýst að gefa
      ekki upp þessi gögn þegar þess er óskað, gætum við ekki framkvæmt samninginn sem við höfum eða erum að reyna að
      gera við þig (til dæmis til útvega þér vörur eða þjónustu). Í þessu tilviki gætum við þurft að hætta við vöru eða
      þjónustu sem þú hefur hjá okkur en við munum láta þig vita ef svo er á þeim tíma.</p>
    <h2>Við notum þessar persónuupplýsingar til að:</h2>
    <ul>
      <li>Staðfesta auðkenni þitt</li>
      <li>Búa til og hafa yfirsýn á reikningnum þínum hjá okkur</li>
      <li>Vinna úr og afhenda pöntunina þína, þar með talið anna greiðslu(m).</li>
      <li>Halda þér uppfærðum með fréttum og upplýsingum sem við teljum eiga við þig</li>
      <li>Sérsníða síðuna okkar eða forrit og innihald hennar að þínum sérstökum óskum</li>
      <li>Láta þig vita um allar breytingar á síðunni okkar eða appi eða þjónustu okkar sem gætu haft áhrif á þig</li>
      <li>Bæta þjónustu okkar</li>
    </ul>
    <h2>Lagagrundvöllur okkar fyrir vinnslu persónulegra upplýsinga þinna</h2>
    <p>Þegar við notum persónuupplýsingar þínar þurfum við að hafa lagalegan grundvöll fyrir að gera það. Það eru ýmsar
      mismunandi lagalegar forsendur sem við getum byggt á, eftir því um hvaða persónuupplýsingar við vinnum með og
      hvers vegna. Lagagrundvöllurinn sem við kunnum að treysta á innihalda:</p>
    <ul>
      <li><strong>Samþykki:</strong> þar sem þú hefur gefið okkur skýrt samþykki fyrir því að við vinnum persónulegar
        upplýsingar þínar í ákveðnum tilgangi.</li>
      <li><strong>Samningur:</strong> þar sem notkun okkar á persónuupplýsingum þínum er nauðsynleg fyrir samning sem
        við höfum meðferðis, eða vegna þess að þú hefur beðið okkur um að gera sérstakar ráðstafanir áður en þú ferð inn
        í samninginn.</li>
      <li><strong>Lagaleg skylda:</strong> þar sem notkun okkar á persónuupplýsingum þínum er nauðsynleg fyrir okkur til
        að fara lögum (ekki meðtaldar samningsskuldbindingar).</li>
      <li><strong>Lögmætir hagsmunir:</strong> eru þegar við erum með fyrirtæki eða verslun og þar af leiðandi ástæðu
        til að nota upplýsingarnar þínar, svo framarlega sem þetta er ekki hnekkt á móti þínum eigin rétti og hagsmunum.
        Við munum framkvæma mat þegar byggt er á lögmætum hagsmunum, að jafnvægi hagsmuna okkar á móti þínum eigin.</li>
    </ul>
    <h2>Markaðssetning</h2>
    <p>Við gætum notað persónuupplýsingar þínar til að senda þér uppfærslur (með tölvupósti) um þjónustu okkar, þar á
      meðal tilboð, kynningar eða nýja þjónustu.</p>
    <p>Við höfum lögmæta hagsmuni af því að nota persónuupplýsingar þínar í markaðslegum tilgangi. Þetta þýðir að við
      þurfum venjulega ekki samþykki þitt fyrir senda þér markaðsupplýsingar. Hins vegar, þar sem samþykkis er þörf,
      munum við biðja um það sérstaklega og skýran máta.</p>
    <p>Við gætum beðið þig um að staðfesta eða uppfæra markaðsstillingar þínar ef þú biður okkur um að veita frekari
      þjónustu í framtíðinni, eða ef breytingar verða á lögum, reglugerðum eða uppbyggingu viðskipta okkar. Við munum
      alltaf meðhöndla persónuupplýsingar þínar af fyllstu virðingu og aldrei selja þær til annarra stofnanna í
      markaðslegum tilgangi.</p>
    <h2>Hverjum við deilum persónuupplýsingunum þínum með</h2>
    <p>Við deilum persónulegum upplýsingum með:</p>
    <ul>
      <li>Þriðja aðila sem við notum til að aðstoða við að afhenda þér vörur okkar og þjónustu, t.d. greiðsluaðila,
        birgja og viðskiptafélaga</li>
      <li>Aðrir þriðju aðilar sem við notum til að aðstoða okkur við að reka fyrirtæki okkar, t.d. markaðsstofur,
        póstþjónustu, kerfisveitum, hýsara vefsíðna, bankans okkar og sendiboðar.</li>
      <li>Þriðju aðilar samþykktir af þér, t.d. samfélagsmiðlasíður sem þú velur til að tengja við reikninginn þinn, eða
        þriðja aðila greiðsluveitenda</li>
      <li>Lánaviðmiðunarstofnanir, eftirlitsstofnanir og önnur yfirvöld sem geta starfað sem vinnsluaðilar sem krefjast
        tilkynningar um vinnslustarfsemi á tilteknum kringumstæðum.</li>
      <li>Við gætum deilt ákveðnum upplýsingum með Google Firebase, sem vinnur úr gögnum fyrir okkar hönd til að veita
        skilaboðaþjónustu, geymslu, rauntíma gagnagrunn og hrungreiningarþjónustu.
      </li>
    </ul>
    <p>Við munum deila persónuupplýsingum með löggæslu eða öðrum yfirvöldum ef þess er krafist er samkvæmt gildandi
      lögum. Við leggjum einnig samningsbundnar skyldur á þjónustuveitendur til að tryggja að þeir geti aðeins nota
      persónuupplýsingar þínar til að veita okkur og þér þjónustu. Við getum líka deilt upplýsingum með ytri
      endurskoðendum. Við kunnum að birta og skiptast á upplýsingum við löggæslustofnanir og eftirlitsstofnana til að
      uppfylla laga- og reglugerðar skyldur. Við gætum líka þurft að deila einhverjum persónulegum upplýsingum með öðrum
      aðilum, svo sem hugsanlega kaupendum að hluta eða öllu fyrirtæki okkar eða á meðan á endurskipulagningu stendur.
      Venjulega eru upplýsingar nafnlausar, but það er ekki alltaf hægt. Viðtakandi af þeim upplýsingum er alltaf bundin
      þagnarskyldu.</p>
    <h2>Þar sem persónuupplýsingar þínar eru geymdar</h2>
    <p>Upplýsingar kunna að vera geymdar á skrifstofum okkar og þjónustu þriðju aðila okkar, þjónustuaðilar, fulltrúar,
      samstarfsaðilar og umboðsmenn eins og lýst er hér að ofan (sjá hér að ofan: „Hverjum við deilum persónulegum
      upplýsingum þínum með').</p>
    <h2>Hversu lengi persónuupplýsingar þínar verða geymdar</h2>
    <p>Við munum geyma persónuupplýsingarnar þínar á meðan þú ert með reikning hjá okkur, eða við erum að veita þér
      vörur og þjónustu. Eftir það munum við halda persónulegum upplýsingum eins lengi og þörf krefur til að:</p>
    <ul>
      <li>að svara öllum spurningum, kvörtunum eða fullyrðingum sem þú eða einhver fyrir þína hönd hefur sett fram;</li>
      <li>til að sýna að við komum fram við þig réttvíslega</li>
      <li>að halda skrár sem krafist er í lögum.</li>
    </ul>
    <h2>Að flytja persónuupplýsingar þínar frá Íslandi</h2>
    <p>Til að veita þér þjónustu er stundum nauðsynlegt fyrir okkur að deila persónulegum gögnum þínum utan Íslands,
      t.d.:</p>
    <ul>
      <li>ef þú ert með aðsetur utan Íslands</li>
    </ul>
    <p>Samkvæmt gagnaverndarlögum getum við aðeins flutt persónuupplýsingar þínar til lands eða alþjóðastofnunar utan
      Íslands þar sem:</p>
    <ul>
      <li>íslensk stjórnvöld eða, þar sem GDPR ESB gildir, framkvæmdastjórn ESB hefur ákveðið að tiltekið land eða
        alþjóðastofnun tryggir fullnægjandi verndarstig persónuupplýsinga (þekkt sem „fullnægjandi ákvörðun“);</li>
      <li>það eru til staðar viðeigandi verndarráðstafanir ásamt aðfararhæfum réttindum og skilvirku réttarúrræði fyrir
        skráða einstaklinga; eða</li>
      <li>sérstök undantekning sem gildir samkvæmt persónuverndarlögum</li>
    </ul>
    <h2>Flutningur með viðeigandi öryggisráðstöfunum</h2>
    <p>Þar sem engin ákvörðun er um hæfi, gætum við flutt persónuupplýsingar þínar til annars landi ef við erum fullviss
      um að flutningurinn sé í samræmi við gagnaverndarlög, viðeigandi verndarráðstafanir eru til staðar og aðfararhæf
      réttindi og skilvirk lagaleg úrræði eru til staðar í boði fyrir skráða einstaklinga. Varnarráðstafanirnar munu
      venjulega fela í sér að nota löglega samþykkta staðlaða gagnavernd.</p>
    <h2>Millifærslur og undantekningar</h2>
    <p>Ef engin ákvörðun er um hæfi eða viðeigandi verndarráðstafanir gætum við flutt persónuupplýsingar til þriðja
      lands eða alþjóðastofnunar þar sem undantekning er gildir samkvæmt viðeigandi persónuverndarlögum, t.d.:</p>
    <ul>
      <li>þú hefur beinlínis samþykkt fyrirhugaðan flutning eftir að hafa verið upplýstur um hugsanlega áhættu;</li>
      <li>flutningurinn er nauðsynlegur til að efna samning milli okkar eða til að gera ráðstafanir fyrir samning að
        beiðni þinni;</li>
      <li>flutningurinn er nauðsynlegur fyrir samning í hagsmunum þínum, milli okkar og annarra manneskja; eða</li>
      <li>flutningurinn er nauðsynlegur til að stofna, nýta eða verja réttarkröfur</li>
    </ul>
    <p>Við gætum einnig flutt upplýsingar í þeim tilgangi að vera sannfærandi lögmæt hagsmunir, svo framarlega sem
      þessir hagsmunir víkja ekki fyrir hagsmunum þínum, réttindum og frelsi. Sérstök skilyrði gilda um slíkar
      millifærslur og við munum veita viðeigandi upplýsingar ef og hvenær við leitumst við að flytja persónuupplýsingar
      þínar á þessum grundvelli.</p>
    <h2>Fullnægjandi ákvörðun framkvæmdastjórnar Evrópusambandsins</h2>
    <p>Framkvæmdastjórn Evrópusambandsins hefur vald til að ákveða hvort land eða alþjóðastofnun veitir fullnægjandi
      vernd fyrir einstaklinga upplýsingar og, ef svo er, að gefa út „fullnægjandi ákvörðun“. Áhrifin af slíkri ákvörðun
      er sú að persónuupplýsingar geti streymt frá Íslandi til þess lands án nokkurra frekari öryggisráðstafana
      nauðsynlegra. Það getur tekið nokkur ár fyrir framkvæmdastjórn Evrópusambandsins að taka ákvörðun um hæfi og
      aðeins örfá lönd njóta góðs af einu eins og er.</p>
    <h2>Að halda persónuupplýsingunum þínum öruggum</h2>
    <p>Við takmörkum aðgang að persónuupplýsingum þínum við þá sem eiga raunveruleg viðskipti og þurfa að fá aðgang að
      því. Þeir sem vinna upplýsingarnar þínar munu aðeins gera það á viðurkenndan hátt og eru bundnir þagnarskyldu.</p>
    <p>Við höfum einnig verklagsreglur til að takast á við hvers kyns grun um gagnaöryggisbrot.</p>
    <p>Við munum láta þig og viðeigandi eftirlitsaðila vita um grun um brot á gagnaöryggi þar sem okkur er lagalega
      skylt að gera það.</p>
    <h2>Hvernig á að kvarta</h2>
    <p>Við vonum að við getum leyst allar fyrirspurnir eða áhyggjur sem þú gætir haft um notkun okkar á upplýsingum
      þínum.</p>
    <p>Persónuverndarreglugerðin veitir þér einnig rétt til að leggja fram kvörtun með eftirlitsyfirvaldi, einkum í
      Evrópusambandinu eða Evrópska efnahagssvæðinu.</p>
    <h2>Breytingar á þessari persónuverndarstefnu</h2>
    <p>Þessi persónuverndartilkynning var birt 08. október 2024 og var síðast uppfærð þá. Við gætum breytt þessari
      stefnu af og til, þegar við gerum það munum við upplýsa þig með tölvupósti. Áframhaldandi notkun þín á vefsíðu eða
      farsímaforriti Ello, eftir allar breytingar á þessari persónuverndarstefnu munu fela í sér samþykki þitt á slíkri
      breytingu.</p>
    <h2>Vafrakökur og önnur rakningartækni</h2>
    <p>Vafrakaka er lítil textaskrá sem er sett á tækið þitt (t.d. tölvu, snjallsíma eða annað raftæki) þegar þú notar
      vefsíðu okkar eða farsíma forrit. Við notum vafrakökur, vefvita, rakningarpixla og aðra rakningu tækni á vefsíðu
      okkar, þar á meðal aðrar fjölmiðlarásir, farsímavefsíður eða farsímaforrit sem tengjast eða tengjast síðunni
      okkar. Þetta hjálpar okkur að þekkja þig og tækið þitt og geyma einhverjar upplýsingar um kjörstillingar þínar eða
      fyrri aðgerðir.</p>
    <h2>Hvernig á að hafa samband við okkur</h2>
    <p>Ef þú vilt hafa samband við okkur, vinsamlegast sendu tölvupóst á ello@ello.is</p>
  </div>

  <div *ngIf="language === 'en'">
    <h1>Privacy Policy</h1>
    <p>Högnun slf. (Reg. No: 4410110910)</p>
    <p>Reykjavík, Iceland</p>
    <p>July 06, 2024</p>
    <p>We ask you to carefully read this website’s privacy policy as it contains important information about who we are,
      how and why we collect, store, use, and share personal information, your rights in relation to your personal
      information, and how to contact us and supervisory authorities if you have a complaint.</p>
    <p>These terms of use (terms) explain how you may use this website (ello.is) or our mobile application (App) and any
      of its content. These terms apply between Ello (we, us, or our) and you, the individual accessing or using our
      site or app (you or your). You should read these terms carefully before using our site or app. By using the site
      or app or otherwise indicating your consent, you agree to be bound by these terms. If you do not agree with any of
      these terms, you should stop using the site or app immediately.</p>
    <p>This privacy policy complies with the requirements of the Data Protection and Processing of Personal Data Act No.
      90/2018, cf. Regulation (EU) 2016/679 of the European Parliament and Council, and was prepared with reference to
      it.</p>
    <h2>About Us</h2>
    <p>We are Ello, a lifestyle app designed for a holistic approach to health.</p>
    <h2>Our Website and Mobile Application</h2>
    <p>This privacy policy relates to your use of our website, ello.is, and mobile application. Our site and app may
      contain links to third-party websites, plug-ins, and applications. By clicking on those links or enabling those
      connections, third parties may be allowed to collect or share data about you. We do not control these third-party
      websites and are not responsible for their privacy statements. When you leave our site or app, we encourage you to
      read the privacy notice of every website you visit.</p>
    <h2>Our Collection and Use of Your Personal Information</h2>
    <p>We collect personal information about you when you access our site or use our app. We collect this personal
      information from you either directly, such as when you contact us, or indirectly, such as your browsing activity
      on our site or app (see “Cookies” below).</p>
    <p>We use Firebase services (including Firebase Messaging, Realtime Database, Storage, and Crashlytics) to support
      essential app functionality. Firebase may collect identifiers (such as device IDs, installation IDs, or crash
      logs) and usage data to enable features like chat messaging, push notifications, real-time data synchronization,
      cloud storage, and crash/error reporting. This data is processed by Google in accordance with their Firebase
      Privacy & Security policies.</p>
    <p>We use Glide, an image loading and caching library, to display and store images within the app. Glide may
      temporarily cache images (including those from external URLs) on your device to improve performance. Glide itself
      does not collect personal information.</p>
    <p>The personal information we collect about you depends on the specific activities carried out through our site or
      app. This information includes:</p>
    <ul>
      <li><strong>Identity Data</strong><br>Includes first name, middle name, last name, username or similar identifier,
        date of birth, and your start date within the app.</li>
      <li><strong>Contact Data</strong><br>Includes billing address, email address, and telephone numbers.</li>
      <li><strong>Financial Data</strong><br>Includes bank account and payment card details or other forms of electronic
        payment and payments you make to us.</li>
      <li><strong>Transaction Data</strong><br>Includes details about payments to and from you and other details of
        products and services you have purchased from us.</li>
      <li><strong>Technical Data</strong><br>Includes internet protocol (IP) address, your login data, browser type and
        version, time zone setting and location, browser plug-in types and versions, traffic data, location data,
        operating system and platform, and other technology on the devices you use to access our site or app.</li>
      <li><strong>Profile Data</strong><br>Includes your username, purchases or orders made by you, feedback, and survey
        responses.</li>
      <li><strong>Usage Data</strong><br>Includes information about how you use our site or app, products, and services.
      </li>
      <li><strong>Marketing and Communications Data</strong><br>Includes your preferences in receiving marketing from us
        and our third parties and your communication preferences.</li>
    </ul>
    <p>We may also collect, use, and share aggregated data such as statistical or demographic data for any purpose.
      Aggregated data may be derived from your personal information but is not considered personal information in law as
      this data does not directly or indirectly reveal your identity. For example, we may aggregate your usage data to
      calculate the percentage of users accessing a specific website feature. However, if we combine or connect
      aggregated data with your personal data so that it can directly or indirectly identify you, we treat the combined
      data as personal information which will be used in accordance with this privacy notice.</p>
    <p>Where we need to collect personal information by law or under the terms of a contract and you choose not to
      provide that data when requested, we may not be able to perform the contract we have or are trying to enter into
      with you (for example, to provide you with goods or services). In this case, we may have to cancel a product or
      service you have with us, but we will notify you if this is the case at the time.</p>
    <h2>We use this personal information to:</h2>
    <ul>
      <li>Verify your identity</li>
      <li>Create and manage your account with us</li>
      <li>Process and deliver your order, including handling payment(s)</li>
      <li>Keep you updated with news and information we consider relevant to you</li>
      <li>Personalize our site or app and its content to your specific preferences</li>
      <li>Notify you about any changes to our site or app or services that may affect you</li>
      <li>Improve our services</li>
    </ul>
    <h2>Our Legal Basis for Processing Your Personal Information</h2>
    <p>When we use your personal information, we need to have a legal basis for doing so. There are various different
      legal bases we may rely on, depending on what personal information we process and why. The legal bases we may rely
      on include:</p>
    <ul>
      <li><strong>Consent:</strong> Where you have given us clear consent for us to process your personal information
        for a specific purpose.</li>
      <li><strong>Contract:</strong> Where our use of your personal information is necessary for a contract we have with
        you, or because you have asked us to take specific steps before entering into a contract.</li>
      <li><strong>Legal Obligation:</strong> Where our use of your personal information is necessary for us to comply
        with the law (not including contractual obligations).</li>
      <li><strong>Legitimate Interests:</strong> Where we have a business or commercial reason to use your information,
        so long as this is not overridden by your own rights and interests. We will carry out an assessment when relying
        on legitimate interests, balancing our interests against your own.</li>
    </ul>
    <h2>Marketing</h2>
    <p>We may use your personal information to send you updates (by email) about our services, including offers,
      promotions, or new services.</p>
    <p>We have a legitimate interest in using your personal information for marketing purposes. This means we do not
      usually need your consent to send you marketing information. However, where consent is required, we will ask for
      it specifically and clearly.</p>
    <p>We may ask you to confirm or update your marketing preferences if you request us to provide further services in
      the future, or if there are changes in the law, regulation, or structure of our business. We will always treat
      your personal information with the utmost respect and never sell it to other organizations for marketing purposes.
    </p>
    <h2>Who We Share Your Personal Information With</h2>
    <p>We share personal information with:</p>
    <ul>
      <li>Third parties we use to assist in delivering our products and services to you, e.g., payment providers,
        suppliers, and business partners.</li>
      <li>Other third parties we use to help us run our business, e.g., marketing agencies, postal services, system
        providers, website hosts, our bank, and couriers.</li>
      <li>Third parties approved by you, e.g., social media sites you choose to link to your account, or third-party
        payment providers.</li>
      <li>Credit reference agencies, regulatory authorities, and other authorities acting as processors who require
        reporting of processing activities in certain circumstances.</li>
      <li>We may share certain information with Google Firebase, which processes data on our behalf to provide
        messaging, storage, real-time database, and crash analytics services.</li>
    </ul>
    <p>We will share personal information with law enforcement or other authorities if required by applicable law. We
      also impose contractual obligations on service providers to ensure they can only use your personal information to
      provide services to us and you. We may also share information with external auditors. We may disclose and exchange
      information with law enforcement agencies and regulatory bodies to comply with legal and regulatory obligations.
      We may also need to share some personal information with other parties, such as potential buyers of some or all of
      our business or during a restructuring. Usually, information will be anonymized, but this is not always possible.
      The recipient of the information is always bound by confidentiality obligations.</p>
    <h2>Where Your Personal Information is Stored</h2>
    <p>Information may be stored at our offices and those of our third-party service providers, suppliers, partners, and
      agents as described above (see above: “Who We Share Your Personal Information With”).</p>
    <h2>How Long Your Personal Information Will Be Kept</h2>
    <p>We will keep your personal information while you have an account with us or we are providing products and
      services to you. Thereafter, we will keep your personal information for as long as is necessary to:</p>
    <ul>
      <li>Respond to any questions, complaints, or claims made by you or on your behalf;</li>
      <li>Show that we treated you fairly;</li>
      <li>Keep records required by law.</li>
    </ul>
    <h2>Transferring Your Personal Information Out of Iceland</h2>
    <p>To provide you with services, it is sometimes necessary for us to share your personal data outside Iceland, e.g.:
    </p>
    <ul>
      <li>If you are based outside Iceland.</li>
    </ul>
    <p>Under data protection law, we can only transfer your personal information to a country or international
      organization outside Iceland where:</p>
    <ul>
      <li>Icelandic authorities or, where the EU GDPR applies, the European Commission has decided that the particular
        country or international organization ensures an adequate level of protection for personal information (known as
        an “adequacy decision”);</li>
      <li>There are appropriate safeguards in place together with enforceable rights and effective legal remedies for
        data subjects; or</li>
      <li>A specific exception applies under data protection law.</li>
    </ul>
    <h2>Transfers with Appropriate Safeguards</h2>
    <p>Where there is no adequacy decision, we may transfer your personal information to another country if we are
      satisfied that the transfer complies with data protection law, appropriate safeguards are in place, and
      enforceable rights and effective legal remedies are available for data subjects. The safeguards will usually
      involve using legally approved standard data protection clauses.</p>
    <h2>Transfers and Exceptions</h2>
    <p>If there is no adequacy decision or appropriate safeguards, we may transfer personal information to a third
      country or international organization where an exception applies under relevant data protection law, e.g.:</p>
    <ul>
      <li>You have explicitly consented to the proposed transfer after being informed of the possible risks;</li>
      <li>The transfer is necessary to perform a contract between us or to take steps at your request prior to entering
        into a contract;</li>
      <li>The transfer is necessary for a contract in your interests, between us and another person; or</li>
      <li>The transfer is necessary to establish, exercise, or defend legal claims.</li>
    </ul>
    <p>We may also transfer information for the purpose of compelling legitimate interests, so long as those interests
      do not override your interests, rights, and freedoms. Specific conditions apply to such transfers, and we will
      provide relevant information if and when we seek to transfer your personal information on this basis.</p>
    <h2>Adequacy Decision by the European Commission</h2>
    <p>The European Commission has the power to determine whether a country or international organization provides an
      adequate level of protection for personal information and, if so, to issue an “adequacy decision.” The effect of
      such a decision is that personal information can flow from Iceland to that country without any further safeguards
      being necessary. It can take several years for the European Commission to make an adequacy decision, and only a
      few countries benefit from one currently.</p>
    <h2>Keeping Your Personal Information Secure</h2>
    <p>We limit access to your personal information to those who have a genuine business need to access it. Those
      processing your information will only do so in an authorized manner and are subject to confidentiality
      obligations.</p>
    <p>We also have procedures to deal with any suspected data security breach.</p>
    <p>We will notify you and any relevant regulator of a suspected data security breach where we are legally required
      to do so.</p>
    <h2>How to Complain</h2>
    <p>We hope that we can resolve any queries or concerns you may have about our use of your information.</p>
    <p>The General Data Protection Regulation also gives you the right to lodge a complaint with a supervisory
      authority, in particular in the European Union or European Economic Area.</p>
    <h2>Changes to This Privacy Policy</h2>
    <p>This privacy notice was published on October 08, 2024, and last updated on that date. We may change this policy
      from time to time; when we do, we will inform you via email. Your continued use of the Ello website or mobile
      application after any changes to this privacy policy will constitute your acceptance of such changes.</p>
    <h2>Cookies and Other Tracking Technologies</h2>
    <p>A cookie is a small text file placed on your device (e.g., computer, smartphone, or other electronic device) when
      you use our website or mobile application. We use cookies, web beacons, tracking pixels, and other tracking
      technologies on our website, including other media channels, mobile websites, or mobile applications related to or
      connected with our site. This helps us recognize you and your device and store some information about your
      preferences or past actions.</p>
    <h2>How to Contact Us</h2>
    <p>If you wish to contact us, please send an email to ello@ello.is.</p>
  </div>
</div>

<style>
  .container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
  }

  .language-toggle {
    margin-bottom: 20px;
    text-align: right;
  }

  .language-toggle button {
    background: #a7b59b;
    color: #fff;
    border: none;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: opacity 0.2s ease-in-out;
    margin-left: 10px;
  }

  .language-toggle button:first-child {
    margin-left: 0;
    /* no extra space before the first button */
  }

  .language-toggle button.active {
    background-color: #7b8873;
    color: white;
  }
</style>